import { SignalDispatcher } from 'ste-signals';

export const sampleEvents = {
  onSampleSentFromSupplier: new SignalDispatcher(),
  onSampleReceivedFromSupplier: new SignalDispatcher(),
  onSampleReadyDateUpdated: new SignalDispatcher(),
  onSamplesLost: new SignalDispatcher(),
  onSampleRemovedFromTransportRequest: new SignalDispatcher(),
  onSamplesUpdated: new SignalDispatcher(),
  onSamplesActionPerformed: new SignalDispatcher(),
};
